export const MuxPlayerEvents = {
  Play: 'play',
  Pause: 'pause',
  Ended: 'ended',
  TimeUpdate: 'timeupdate',
  Error: 'error',
  LoadedMetadata: 'loadedmetadata',
} as const;

export const MediaErrorCode = {
  Aborted: 1,
  Network: 2,
  Decode: 3,
  SrcNotSupported: 4,
} as const;

export const MuxErrorCode = {
  NetworkTokenExpired: 2403210,
} as const;

export interface MuxPlayerEventDetail {
  currentTime?: number;
  duration?: number;
  ended?: boolean;
  error?: Error;
  errorCode?: number;
  muxErrorCode?: number;
}
